import './qoutation-displayer/universal-qoutation-displayer/universal-quatation-displayer.module';
